// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Smgc0","footer":"ModalError_footer__1oMgD"};